import React, { memo } from 'react';

import { AqiActiveHealthAdviceIcon } from '../../common/icons/aqiActiveHealthAdviceIcon';
import { AqiChildrenHealthAdviceIcon } from '../../common/icons/aqiChildrenHealthAdviceIcon';
import { AqiGeneralHealthAdviceIcon } from '../../common/icons/aqiGeneralHealthAdviceIcon';
import { AqiLungAndHeartDiseaseIcon } from '../../common/icons/aqiLungAndHeartDiseaseIcon';

import { HealthAdviceTypes } from './types';

interface HealthAdviceIconProps {
    healthAdviceName: keyof typeof HealthAdviceTypes;
    iconFillColor?: string;
}

export const HealthAdviceIcon = memo(({ healthAdviceName, iconFillColor }: HealthAdviceIconProps) => {
    if (!healthAdviceName) {
        return null;
    }
    
    if (healthAdviceName === HealthAdviceTypes?.general) {
        return <AqiGeneralHealthAdviceIcon symbolFillColor={iconFillColor} />;
    } else if (healthAdviceName === HealthAdviceTypes?.lungAndHeartDisease) {
        return <AqiLungAndHeartDiseaseIcon symbolFillColor={iconFillColor} />;
    } else if (healthAdviceName === HealthAdviceTypes?.children) {
        return <AqiChildrenHealthAdviceIcon symbolFillColor={iconFillColor} />;
    } else if (healthAdviceName === HealthAdviceTypes?.active) {
        return <AqiActiveHealthAdviceIcon symbolFillColor={iconFillColor} />;
    } else { // defaults to this?
        return <AqiGeneralHealthAdviceIcon symbolFillColor={iconFillColor} />;
    }
});

HealthAdviceIcon.displayName = 'HealthAdviceIcon';
